import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("CustomDataTerminal", "StringCompareTerminal", {
    defaults: {
      value: "",
      partner_name: "",
      relop: "="
    },

    type: function() {
      return 'CustomData';
    },

    _textPrefix: function() {
      return this.get('terminal') + "[" + this.get('partner_name') + "]";
    }
  });
});
